'use strict';

;( () => {
	document.addEventListener( 'alpine:init', () => {

		Alpine.data( 'featureText', () => ({

			verticalPositionPercentage: 0,

			init() {
				window.addEventListener( 'scroll', this.updateVerticalPosition.bind( this ) );
				window.addEventListener( 'resize', this.updateVerticalPosition.bind( this ) );
				this.updateVerticalPosition();
			},

			updateVerticalPosition() {
				const element        = document.getElementById( 'feature-text' );
				if ( ! element ) return; // Insurance in case the parent element doesn't exist.

				const spans          = element.querySelectorAll( 'span' );
				const rect           = element.getBoundingClientRect();
				const viewportHeight = window.innerHeight;
				const elementTop     = rect.top;
				const className      = 'text-stealth-80';
				const total          = spans.length;

				// Flip so percentage starts at 0 (when element top is at the start threshold)
				// and goes to 100 by the time it reaches the end threshold.
				// On mobile (< 1024px), animEnd is derived from element height so the animation
				// completes when the bottom of the element reaches the bottom of the viewport,
				// preventing all text from revealing before the element is fully in view.
				const isMobile  = 1024 > window.innerWidth;
				const animStart = viewportHeight * 0.7;
				const animEnd   = isMobile ? viewportHeight - element.offsetHeight : viewportHeight * 0.2;
				const invertedProgress = ( ( animStart - elementTop ) / ( animStart - animEnd ) ) * 100;

				this.verticalPositionPercentage = invertedProgress.toFixed( 2 );

				// Clamp to 0–100 so that >100 fully reveals all spans.
				const percentage = Math.max( 0, Math.min( 100, parseFloat( this.verticalPositionPercentage ) ) );
				element.style.setProperty( '--percentage', `${percentage}%` );

				// Reveal from top down.
				const revealCount = Math.floor( ( percentage / 100 ) * total );

				spans.forEach( ( span, index ) => {

					if ( index < revealCount ) span.classList.remove( className );
					else span.classList.add( className );
				});
			}
		}) );
	});
})();
